import store from 'store2'
// import { objectToUrlParams, createGUID } from '@/utils/tools'
const TokenKey = 'Admin-Token'
// const NasFileHost = 'NAS-FILE-HOST'
// const SSOSettingKey = 'SSO-Setting'
// const SecretSettingKey = 'SECRET-SETTING'

// var oidcSettings = {
//   authority: '',
//   client_id: 'a5cae5535dc24add98b60ce1f3a8915d',
//   redirect_uri: window.location.origin + '/oidc-callback',
//   post_logout_redirect_uri: window.location.origin + '/oidc-callback',
//   response_type: 'id_token token',
//   scope: 'openid profile Acadsoc.Teacher.Api'
// }

// export function getSSOSettings () {
//   return store.get(SSOSettingKey)
// }

// export function setAuthorityUrl (url) {
//   oidcSettings.authority = url
//   return store.set(SSOSettingKey, oidcSettings)
// }

// export function setAppSetting (setting) {
//   return store.set(SecretSettingKey, {
//     appId: setting.AppId || '',
//     secret: setting.AppSecret || ''
//   })
// }
// export function getAppSetting () {
//   return store.get(SecretSettingKey)
// }

export function getToken () {
  return store.get(TokenKey)
}

export function setToken (token) {
  return store.set(TokenKey, token)
}

export function removeToken () {
  return store.remove(TokenKey)
}
// export function setNasFileHost (host) {
//   return store.set(NasFileHost, host)
// }
// export function getNasFileHost () {
//   return store.get(NasFileHost)
// }

// export function getAuthUrl () {
//   let settings = getSSOSettings()
//   let requestUrl = settings.authority
//   delete settings['authority']
//   settings.state = createGUID().replace('-', '')
//   settings.nonce = createGUID().replace('-', '')
//   return requestUrl + '?' + objectToUrlParams(settings).trim('&')
// }
